import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
} from '@chakra-ui/react';

import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';
import { OriginalMenu } from 'types/menu';

export type Props = {
  menus: OriginalMenu[];
  register: UseFormRegister<ContractFormFields>;
  error: FieldError | undefined;
};

/**
 * 有効/無効のフォームです。
 */
export const MenuForm: FC<Props> = ({ menus, register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>メニュー名</FormLabel>
    <Select
      {...register('menuId', {
        required: '必須項目です。',
      })}
    >
      {menus.map((menu) => (
        <option key={menu.id} value={menu.id}>
          {`${menu.id}: ${menu.name}`}
        </option>
      ))}
    </Select>
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
